import { render, staticRenderFns } from "./SosPosition.vue?vue&type=template&id=75b95697&scoped=true&"
import script from "./SosPosition.vue?vue&type=script&lang=js&"
export * from "./SosPosition.vue?vue&type=script&lang=js&"
import style0 from "./SosPosition.vue?vue&type=style&index=0&id=75b95697&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b95697",
  null
  
)

export default component.exports